import { api } from './client.ts';

export interface AccountDeletionResult {
  deleted: true;
  scope: 'company' | 'user';
  subscriptionCanceled: boolean;
}

export function deleteAccount(confirmation: string): Promise<AccountDeletionResult> {
  return api.post<AccountDeletionResult>('/account/deletion', { confirmation });
}
